import { enqueueSnackbar } from "notistack";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../../api";

export const useAutoGenerateQuiz = () => {
  const ApiClient = useApiClient();
  const navigate = useNavigate();

  const autoGenerateQuiz = async ({
    quizDetails,
    context,
    payload,
    onSameQuiz,
    files,
    assignment = null,
    skipRedirect = false,
  }) => {
    try {
      const response = await ApiClient.quiz.generateQuizGroup({
        name: quizDetails.name,
        description: quizDetails.description,
        dueDate: dayjs(quizDetails.dueDate).format("YYYY-MM-DD"),
        schoolClass: quizDetails.schoolClass?.id,
        quizContext: context,
        payload: payload,
        files: files,
        assignment: assignment,
        quizGroup: quizDetails.id || null,
      });

      if (!response.success) {
        enqueueSnackbar(response.message, { variant: "error" });
        return;
      }

      enqueueSnackbar("Quiz is being generated", {
        variant: "success",
        autoHideDuration: 3000,
      });

      if (response.quizGroup?.id === quizDetails?.id || skipRedirect) {
        onSameQuiz?.();
      } else {
        navigate(`/quizzes/view/${response.quizGroup.id}`);
      }
    } catch (err) {
      enqueueSnackbar("Error submitting, please try again", {
        variant: "error",
      });
    }
  };

  return { autoGenerateQuiz };
};
